/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CreditCard/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Checkbox from 'DesignSystem/Checkbox/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function CreditCard({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/TreatmentRequestOverride/Content/Downpayment/CreditCard"
  
}) {
let rulesetDownpaymentPaymentMethodsValueData = fromData.useDataValue({ viewPath,
context: 'ruleset',
path: 'downpayment_payment_methods',
})
let constantData = 'credit_card'
let aggregateData = fromAggregate.includes(rulesetDownpaymentPaymentMethodsValueData, constantData)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<Checkbox
  viewPath={`${viewPath}/Checkbox`}
 data="ruleset.downpayment_payment_methods"
 data="'credit_card'"
 aggregate="/Data/aggregate.js includes"
 isSelected={aggregateData}
 onClick={onClick}
 marginLeft={dtSpaceXxs}
 text="CREDIT CARD"
/>
{children}
</React.Fragment>)
}